module.exports = __webpack_public_path__ + "static/img/v.d21cb660.png";